/**
 * @generated SignedSource<<35352921f50ee3ccb5bbaa1e48c95279>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type validationContainerQuery$variables = {
  modelName: string;
  owner?: string | null;
};
export type validationContainerQuery$data = {
  readonly validationContainers: ReadonlyArray<{
    readonly containerId: number;
    readonly isCustomTable: boolean;
    readonly tableAlias: string;
    readonly tableName: string;
  } | null> | null;
};
export type validationContainerQuery = {
  response: validationContainerQuery$data;
  variables: validationContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "modelName",
        "variableName": "modelName"
      },
      {
        "kind": "Variable",
        "name": "owner",
        "variableName": "owner"
      }
    ],
    "concreteType": "ValidationContainerInfo",
    "kind": "LinkedField",
    "name": "validationContainers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tableName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tableAlias",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "containerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCustomTable",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "validationContainerQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "validationContainerQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7965ceb5486ff42665f8de6de35f6662",
    "id": null,
    "metadata": {},
    "name": "validationContainerQuery",
    "operationKind": "query",
    "text": "query validationContainerQuery(\n  $owner: String\n  $modelName: String!\n) {\n  validationContainers(owner: $owner, modelName: $modelName) {\n    tableName\n    tableAlias\n    containerId\n    isCustomTable\n  }\n}\n"
  }
};
})();

(node as any).hash = "e8555584ddfea09c9257467a7934a7fe";

export default node;
